<div style="flex-direction:row;" class="aside-wrapper gray-100 ">
  <div style="display:block;" class="icon-circle-background">
    <span style="font-size:28px;color:white !important;position:relative;top:8px;left:10px;" class=" user-card text-blue-five icon-doc "></span>
  </div>
  
  <ul class="ml-2 text-break no-bullets " style="width:135px;font-size:90%;">
    <li class="mb-2">
      <span style="color: var( --bs-primary)">{{'WorkflowCreatePM.Documents.DocumentsNeeded.Title' | translate}}&nbsp;&nbsp;&nbsp;</span>
      <span style="color: var( --bs-primary); cursor: pointer;" [ngClass]="!expandedView?'icon-down':'icon-up'" (click)="expandedView=!expandedView"></span>
    </li>
    <li style="width:100%;" *ngFor="let person of documentsPerPerson">
      
      <table style="width:100%;"  >
        <tbody style="width:100%;" >
          <tr style="width:100%;" >
            <td style="width:90%">
              <span style="color: var( --bs-primary); font-size: 80%;">{{person.namePerson}}</span>
            </td>
            <td style="width:10%">
              <span style="font-size:80%;">{{person.documents.length}}</span>
            </td>
          </tr>
          <ng-container style="width:100%;"  *ngIf="expandedView" >
            <tr style="width:100%;"  *ngFor="let doc of person.documents">
              <td colspan="2" class="document-item">{{doc.name}}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </li>
  </ul>
</div>
